export const MonetizationStore = {
    "planDetails" : {},
    "currentSelectedPlan" : {},
    "firstPayment" : {},
    "subscriptionData" : {}
}